$(document).on 'ready page:load turbolinks:load', (event) ->
  set_datepicker()

set_datepicker = ->
  datepicker = $('input.date_picker')
  format = datepicker.data('format')
  datepicker.Zebra_DatePicker({format: format})
  return